// Copyright (c) 2017 Deere & Company

import Facets from '../state/facets';
import actions from '../../actions-list';
import {getDefaultState} from '../state';
import {getDefaultState as getRangeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/range';
import {updateList} from '../../../shared/services/list-selections';

const resetFacets = state =>
    Facets.update(state, {
        $merge: {
            ...getDefaultState().facets,
            allowedClaimTypes: state.allowedClaimTypes,
            allowedProductHierarchy: state.allowedProductHierarchy,
            selectedClaimTypes: state.allowedClaimTypes
        }
    });

const updateAllowedClaimTypes = (state, action) =>
    Facets.update(state, {
        $merge: {
            allowedClaimTypes: action.claimTypes,
            selectedClaimTypes: action.claimTypes
        }
    });

const updateClaimTypeSelected = (state, action) =>
    Facets.update(state, {
        selectedClaimTypes: {
            $set: updateList(
                action.item,
                action.isSelected,
                'key',
                state.selectedClaimTypes
            )
        }
    });

const updateClaimTypeToggled = (state, action) => {

    const updatedClaimTypes = state.selectedClaimTypes.length ?
        [] :
        action.claimTypes;

    return Facets.update(state, {
        selectedClaimTypes: {
            $set: updatedClaimTypes
        }
    });

};

const updateRangeFacet = (state, action) =>
    Facets.update(state, {
        [action.property]: {
            $set: action.range
        }
    });

const showReimbursedAmount = state =>
    Facets.update(state, {
        $merge: {
            reimbursedPercentage: getRangeDefaultState(),
            showReimbursedAmount: true
        }
    });

const showReimbursedPercent = state =>
    Facets.update(state, {
        $merge: {
            reimbursedAmount: getRangeDefaultState(),
            showReimbursedAmount: false
        }
    });

const updateSelectedProductCode = (state, action) =>
    Facets.update(state, {
        selectedProductCode: {
            $set: action.productCode
        }
    });

const updateAllowedProductHierarchy = (state, action) =>
    Facets.update(state, {
        allowedProductHierarchy: {
            $set: action.data
        }
    });

export default (state = getDefaultState().facets, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_AUDIT_CLAIM_FACETS]: resetFacets,
        [actions.TOGGLE_TCSM_AUDIT_CLAIM_REIMBURSED_AMOUNT]: showReimbursedAmount,
        [actions.TOGGLE_TCSM_AUDIT_CLAIM_REIMBURSED_PERCENT]: showReimbursedPercent,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPES]: updateAllowedClaimTypes,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_DATE_ISSUED]: updateRangeFacet,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_REIMBURSEMENT_RANGE_DOLLARS]: updateRangeFacet,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_REIMBURSEMENT_RANGE_PERCENT]: updateRangeFacet,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPE_SELECTED]: updateClaimTypeSelected,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPE_TOGGLED]: updateClaimTypeToggled,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_PRODUCT_HIERARCHY_SELECTED]: updateSelectedProductCode,
        [actions.UPDATE_TCSM_AUDIT_CLAIM_PRODUCT_HIERARCHY_SUCCESS]: updateAllowedProductHierarchy
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/reducers/facets.js